
import { useQuery } from '@tanstack/react-query';
import { fetchProductsForProfiles } from './services/dataFetcher';
import { ProfileProductsResponse } from './types/productTypes';

export const useFetchProducts = (profileIds: string[]) => {
  return useQuery({
    queryKey: ['profile-products', profileIds],
    queryFn: async (): Promise<ProfileProductsResponse> => {
      // Si aucun profil n'est sélectionné, retournez un tableau vide
      if (profileIds.length === 0) {
        return { products: [], profileName: undefined };
      }
      
      try {
        // Fetch products for the selected profiles
        return await fetchProductsForProfiles(profileIds);
      } catch (error) {
        console.error('Error fetching products for profiles:', error);
        throw error;
      }
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: profileIds.length > 0
  });
};
